import styled, {css, keyframes} from 'styled-components';
import {Palette} from 'hubbl-shared';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const DropdownContainer = styled.div<{align?: 'left' | 'right'}>`
  position: absolute;
  top: 100%;
  ${props =>
    props.align === 'left'
      ? css`
          right: 0;
        `
      : css`
          left: 0;
        `}
  margin-top: 8px;
  background: ${Palette.white};
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  min-width: 160px;
  z-index: 1000;
  text-align: left;
  animation: ${fadeIn} 0.2s ease-out;
  transform-origin: top;
`;
